import { render, staticRenderFns } from "./dictionary-category.vue?vue&type=template&id=6a689049&scoped=true&"
import script from "./dictionary-category.vue?vue&type=script&lang=js&"
export * from "./dictionary-category.vue?vue&type=script&lang=js&"
import style0 from "./dictionary-category.vue?vue&type=style&index=0&id=6a689049&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a689049",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a689049')) {
      api.createRecord('6a689049', component.options)
    } else {
      api.reload('6a689049', component.options)
    }
    module.hot.accept("./dictionary-category.vue?vue&type=template&id=6a689049&scoped=true&", function () {
      api.rerender('6a689049', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sms-system-management/dictionary-category.vue"
export default component.exports